import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

import DepotGestionAutocomplete from 'components/Shared/DepotGestionAutocomplete';

import DropZone from 'components/Shared/DropZone';
import { ReclamationActionDetailCodes, ReclamationActionDetailType, CodeDepot } from 'constants.js';

import stringHelper from 'utils/stringHelper';

import { MotifResolutionCodes } from 'constants.js';
import { CausePrincipaleCodes } from 'constants.js';


const styles = {
    formControl: {
        margin: 0,
        marginTop: 10,
        width: '100%'
    },

    heightLabel: {
        height: '30px'
    },

    input: {
        marginTop: 10
    }
};

class ProblemeQualiteProduitDialogContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            articles: props.articles ? props.articles.filter(x => x.gereEnStock === true) : undefined,
            defaut: '',
            numeroPiece: props.piece ? `${props.piece.numeroPiece} / ${props.piece.numeroPreparation} du ${new Date(props.piece.dateCreation).toLocaleDateString("fr-FR", { day: "numeric", month: "numeric", year: "numeric" })}` : '',
            demanderReprise: null,
            actionEffectuee: '0',
            fichiersIds: [],
            codeDepot: props.codeDepot,
            depotDepart: props.depotDepart
        };
    }

    componentDidMount() {
        const actionData = this.getActionData(this.state);

        this.props.onChange(actionData);
    }

    getActionData(newState) {
        const { action, depotDepart } = this.props;

        if (!newState.codeDepot) {
            return null;
        }

        if (newState.demanderReprise === null) {
            return null;
        }

        if (stringHelper.isNullOrWhitespace(newState.defaut)) {
            return null;
        }

        const actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Depot,
                type: ReclamationActionDetailType.CodeDepot,
                libelle: 'Dépôt concerné',
                position: 0,
                valeurString: newState.codeDepot
            }, {
                code: ReclamationActionDetailCodes.Memo,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Défaut constaté',
                position: 1,
                valeurString: newState.defaut
            }, {
                code: ReclamationActionDetailCodes.NumeroPiece,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Numéro de pièce cession',
                position: 2,
                valeurString: newState.numeroPiece
            }, {
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.Booleen,
                    libelle: depotDepart === CodeDepot.PlateformeVaulx ? 'Demander une reprise par la plateforme Vaulx ?' : 'Demander une reprise par la plateforme Monné ?',
                position: 3,
                valeurBool: newState.demanderReprise === '0' ? true : false
            }, {
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Action déjà effectuée vis à vis du client',
                position: 4,
                valeurString:   newState.actionEffectuee === '0' ? 'Échange produit en magasin' :
                                newState.actionEffectuee === '1' ? 'Avoir client en magasin' :
                                newState.actionEffectuee === '2' ? 'Relivraison (enlèvement agence)' : 'Relivraison (livraison client)'
            }]
        };

        if (newState.fichiersIds.length > 0) {
            actionData.fichiersIds = newState.fichiersIds;
        }

        return actionData;
    }

    handleChange = (event) => {

        console.log("handleChange", event.target.name, event.target.value )

        const newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        const actionData = this.getActionData(newState);
        
        let clotureData = null;

        if (actionData) {

            clotureData = {
                motifResolutionCode: MotifResolutionCodes.AvoirClientAvecRetour,
                causePrincipaleCode: CausePrincipaleCodes.ProblemeQualiteFournisseur,
                causePrincipaleDetailId: 0,
                utilisateurFautifId: 0,
                commentaire: '',
                mailAutomatique: ''
            };

            switch (newState.actionEffectuee) {
                case '0': // 'Échange produit en magasin'
                    clotureData.motifResolutionCode = MotifResolutionCodes.AvoirClientAvecRetour;
                    break;
                case '1': // 'Avoir client en magasin'
                    clotureData.motifResolutionCode = MotifResolutionCodes.AvoirClientAvecRetour;
                    break;
                case '2': // 'Relivraison (enlèvement agence)'
                    clotureData.motifResolutionCode = MotifResolutionCodes.RenvoiMarchandiseFacture;
                    break;
                case '3': // 'Relivraison (livraison client)'
                    clotureData.motifResolutionCode = MotifResolutionCodes.RenvoiMarchandiseFacture;
                    break;
                default:
                    break;
            }
        }

        this.props.onChange(actionData, clotureData);
    }

    render() {
        const { classes } = this.props;
        const { articles, defaut, demanderReprise, actionEffectuee, numeroPiece, codeDepot, depotDepart } = this.state;
        
        return (
            <DialogContent>
                <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>
                <Typography variant="body2" gutterBottom className={classes.detailValue}>{`Générer un dossier après-vente lié affecté au groupe Qualité Entrepôt`}</Typography>


                <FormControl margin="normal" className={classes.formControl}>
                    <DepotGestionAutocomplete
                        value={codeDepot}
                        onChange={(e, codeDepot, depot) => { this.handleChange({ target: { name: 'codeDepot', value: codeDepot } }); }}
                        label={"Dépôt"}
                        magasinsSeulement={false}
                        plateformesSeulement={false}
                        autoFocus
                        modeTri={0}
                        required={true}
                        disabled={false}
                    />
                </FormControl>


                
                {articles && articles.map((value, index) => {
                    if (value.codeArticle !== null)
                        return (
                            <Stack key={index} direction={"row"} spacing={1} mt={1}>
                                <TextField disabled label="Code article" value={value.codeArticle} />
                                <TextField disabled label="Quantité" value={value.quantite} />
                            </Stack>
                        );
                    else
                        return null;
                })}

                <TextField className={classes.input} required id="defaut" name="defaut" label="Défaut constaté" value={defaut} onChange={this.handleChange} fullWidth multiline />

                <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend">{depotDepart === "70" ? "Demander une reprise par la plateforme Vaulx ?" : "Demander une reprise par la plateforme Monné ?" }</FormLabel>
                    <RadioGroup id="demanderReprise" name="demanderReprise" className={classes.group} value={demanderReprise} onChange={this.handleChange}>
                        <FormControlLabel className={classes.heightLabel} value="0" control={<Radio />} label="Oui" />
                        <FormControlLabel className={classes.heightLabel} value="1" control={<Radio />} label="Non" />
                    </RadioGroup>
                </FormControl>

                <TextField className={classes.input} id="numeroPiece" name="numeroPiece" label="Numéro pièce plus récent contenant l'article" value={numeroPiece} onChange={this.handleChange} fullWidth />

                <TextField
                    id={'actionEffectuee'}
                    name={'actionEffectuee'}
                    label={"Action déjà effectuée vis à vis du client"}
                    fullWidth
                    sx={{mt:1}}

                    select
                    SelectProps={{
                        value: actionEffectuee,
                        onChange: this.handleChange
                    }}
                >
                    <MenuItem value="0">Échange produit en magasin</MenuItem>
                    <MenuItem value="1">Avoir client en magasin</MenuItem>
                    <MenuItem value="2">Relivraison (enlèvement agence)</MenuItem>
                    <MenuItem value="3">Relivraison (livraison client)</MenuItem>
                </TextField>


                <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
            </DialogContent>
        );
    }
}

ProblemeQualiteProduitDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    codeDepot: PropTypes.string
};

export default withStyles(styles)(ProblemeQualiteProduitDialogContent);